import { useSettingsStore } from '@starsoft/common/hooks';
import { NavigateProps } from './props';

/**
 * Navigate Component
 * A wrapper component that renders a router Navigate component based on the current settings.
 * Uses the router Navigate component defined in the settings store.
 * Returns null if no Navigate component is configured.
 *
 * @component
 * @param {NavigateProps} props - Props to be passed to the underlying Navigate component
 * @returns {JSX.Element|null} The rendered Navigate component or null if not configured
 *
 * @example
 * // Navigate to a new route
 * <Navigate to="/dashboard" />
 *
 * // Navigate with state and replace
 * <Navigate
 *   to="/profile"
 *   state={{ from: 'home' }}
 *   replace={true}
 * />
 */
export function Navigate(props: NavigateProps) {
  const { state } = useSettingsStore();
  const Navigate = state.settings.router.Navigate;

  if (!Navigate) {
    return null;
  }

  return <Navigate {...props} />;
}
